export default "__VITE_PUBLIC_ASSET__242e51dd__"